import type { HandoverType } from '../../types/ads';

export const DISTRESS_MINIMUM_DISCOUNT = 0.05;

export const getCurrentHandover = (date = new Date()): Required<HandoverType> => ({
  quarter: `Q${Math.floor(date.getMonth() / 3) + 1}`,
  year: String(date.getFullYear()),
});

export const calculatePaymentAmounts = (
  relevantPrice: number | null,
  currentToSeller: number | null
) => {
  const price = relevantPrice ?? 0;
  const toSeller = currentToSeller ?? 0;

  if (price <= 0) {
    return { toDeveloper: 0, toSeller: 0 };
  }

  if (price <= toSeller) {
    return { toDeveloper: 0, toSeller: price };
  }

  return { toDeveloper: price - toSeller, toSeller };
};

export const hasValidDistressDiscount = (
  originalPrice: number | null,
  sellingPrice: number | null
) => {
  if (originalPrice === null || sellingPrice === null) {
    return true;
  }

  return sellingPrice <= originalPrice * (1 - DISTRESS_MINIMUM_DISCOUNT);
};
